import React from "react";
import { Route, Redirect } from "react-router-dom";
import { hasAnyValidToken } from "../authHelper";

// Private Route component
export const PrivateRoute = ({ component: Component, ...rest }) => {
  const isValidToken = hasAnyValidToken();

  return <Route {...rest} render={(props) => (isValidToken ? <Component {...props} /> : <Redirect to="/login" />)} />;
};
